// TableHeader.js
import React from 'react';

const TableHeader = ({ columns }) => (
    <thead>
        <tr>
            <th className="text-center">Loc.</th>
            {columns.map((col) => (
                <th key={col.key} className="d-none d-md-table-cell">
                    {col.label}
                </th>
            ))}
        </tr>
    </thead>
);

export default React.memo(TableHeader);
